import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import IconDownArrow from "./icon-down-arrow.svg";
import IconUpArrow from "./icon-up-arrow.svg";

export const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  inline-size: 407px;
  block-size: 864px;
`;

export const StyledIframe = styled.iframe`
  inline-size: 100%;
  block-size: 100%;

  overflow: hidden scroll;
  -webkit-overflow-scrolling: touch;
`;

export const Hint = styled.div`
  inline-size: 42px;
  margin-inline-end: -28px;

  font-size: 12px;
  font-family: ${fontRoboto};
`;
export const SwipeDown = styled(IconDownArrow)`
  margin-block-start: 9px;
`;
export const SwipeUp = styled(IconUpArrow)`
  margin-block-end: 9px;
`;

export const HintContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  margin-inline-start: 22px;

  ${theme.breakpoints.up("desktop")} {
    margin-inline-start: 11px;
  }
`;
